  <template>
  <section class="components-list-discuss">
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <!-- <h4 class="text-right rtl font-18 mb-4">
            {{title}}
          </h4>-->
          <div v-for="(value, name,index) of _items" :key="index">
            <div class="card-header rtl text-right" v-b-toggle="'div'+index">
              <toggle-open />
              {{name === 'undefined' ?  title : name}}
            </div>
            <!-- @show="$emit('getDiscussReply',item,index)" -->
            <b-collapse :id="'div'+index" :visible="index === expanded" accordion="my-accordion">
              <div class="content px-2 py-3">
                <div
                  class="d-flex flex-column row-item py-2"
                  v-for="(item,index) in value"
                  :key="index"
                >
                  <div class="panel-body-header p-3 mb-2 justify-content-start rtl text-right">
                    <div class="d-flex flex-md-row flex-column">
                      <div class="col-12 col-md-10">
                        <questioner :item="item" />
                      </div>
                      <div class="col-12 col-md-2" v-if="isAdmin">
                        <div class="d-flex">
                          <button
                            @click="$emit('editDiscuss',item,index)"
                            class="mt-1 mb-1 bttn-material-circle bttn-md bttn-success flaticon-content mr-auto"
                            v-ripple
                            :title="'ویرایش سوال'"
                          ></button>
                          <button
                            @click="$emit('discussDelete',item,index)"
                            class="mt-1 mb-1 bttn-material-circle bttn-material-circle bttn-md bttn-danger flaticon-dustbin mr-auto"
                            v-ripple
                            :title="'حذف سوال'"
                          ></button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex flex-row justify-content-between mb-1">
                    <div class="title align-self-center">
                      <p
                        class="mb-0 text-right font-14 d-inline-block"
                        v-if="!isAdmin"
                        @click="$emit('replyDiscuss',item,index)"
                      >به این سوال جواب دهید</p>
                    </div>
                    <div class="title align-self-center">
                      <p
                        class="mb-0 text-right font-14 d-inline-block"
                        @click="$emit('getDiscussReply',item,index)"
                      >مشاهده جواب ها</p>
                    </div>
                  </div>
                  <div class="d-flex flex-column" v-if="item.replies.length">
                    <h5 class="text-right">
                      <p class="text-dark font-14 mt-1">لیست جواب ها به این سوال</p>
                    </h5>
                    <replies
                      :isAdmin="isAdmin"
                      @editReplies="$emit('editReplies',item,index,replie,j)"
                      :item="replie"
                      v-for="(replie,j) in item.replies"
                      :key="replie.id"
                    />
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import toggleOpen from "cp/min-component/open-colose.vue";
import questioner from "cp/questioner.vue";
import replies from "cp/replies.vue";
import _ from "underscore";

export default {
  props: ["title", "items", "isAdmin"],
  name: "components-list-discuss",
  components: {
    toggleOpen,
    replies,
    questioner
  },
  methods: {
    expandAll() {},
    my_custom_action: function(vm) {
      this.open = !vm.status;
    }
  },
  data() {
    return {
      open: true,
      expanded: 1,
      text: `Anim pariatur clichemus labore VHS.`
    };
  },
  computed: {
    _items() {
      let items = this.items;
      return _.groupBy(items, e => e.course_title);
    }
  },

  mounted() {
    var vm = this;
    setTimeout(() => {
      vm.expanded = 0;
    }, 0.4);
  }
};
</script>
<style lang="less">
@import (reference) "../assets/css/variable.less";
@blueLine: #007791;
.components-list-discuss {
  .box-clear;
  .panel-body-header {
    background: #f9f9f9;
    color: @secondaryTextColor;
  }
  .card-header {
    cursor: pointer;
    display: flex;
    align-items: center;
    background: #f9f9f9;
    border: 1px solid @e3;
    cursor: pointer;
    height: auto;
    margin-top: 3px;
    padding: 10px 15px 10px 10px;
    color: @secondaryTextColor;
    i {
      margin-left: 10px;
    }
  }
  .answer {
    background: #7b7b7b;
    color: #f3f3f3;
  }
  .content {
    background-color: @withe;
  }
  .row-item {
    border-bottom: 1px solid @e3;
    &:last-child {
      border-bottom: none;
    }
    .title {
      p {
        cursor: pointer;
      }
      color: @blueLine;
      i {
        transform: scale(-1, -1);
      }
    }
    .info {
      color: @blueLine;
      p {
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/list-discuss.vue